// extracted by mini-css-extract-plugin
export default {"find-doctor-page":"SetLocation_find-doctor-page__dh+kw","sub-heading":"SetLocation_sub-heading__C-reF","find-doctor-form":"SetLocation_find-doctor-form__+a0gD"};